export const YUP_MESSAGES = { required: "Obrigatório" };
